import axios from "axios";
import { defineStore } from "pinia";
import * as Sentry from "@sentry/vue";
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

// import line from "@line/bot-sdk";
export const useStore = defineStore("token", {
  state: () => {
    return {
      _lineAccessToken: "",
      _lineUserId: "",
    };
  },

  getters: {
    lineAccessToken(): string {
      return this._lineAccessToken;
    },
    lineUserId(): string {
      return this._lineUserId;
    },
  },

  actions: {
    // stateで定義したデータの更新
    setAccessToken(token: string) {
      this._lineAccessToken = token;
    },
    setLineUserId(userId: string) {
      if (userId) {
        this._lineUserId = userId;
      }
      if (!userId) Sentry.captureMessage(userId + "userIdがない！");
    },
  },
});
